import {
    CLEAR_ALL_MARKETS,
    GET_ALL_MARKETS_REQUEST,
    GET_MARKET_GROUPS,
    SET_ALL_MARKETS_SELECTED_EVENT,
    SET_FILTERED_MARKET_GROUPS,
    SET_MARKETS_COLLAPSED,
    SET_SELECTED_MARKET_GROUP,
} from '../actions/types';
import { MARKET_GROUPS_ALL_ID } from '../../constants/defaultValues';
import LocalStorage from '../../utils/localStorage';

const initialState = {
    markets: [],
    loading: false,
    selectedEvent: {},
    marketGroups: [],
    filteredMarketGroups: [],
    selectedMarketGroup: MARKET_GROUPS_ALL_ID,
    isMarketsCollapsed: LocalStorage.getItem('isMarketsCollapsed') ?? false,
};

export default function (state = initialState, action) {
    const { payload } = action;

    switch (action.type) {
        case GET_ALL_MARKETS_REQUEST:
            return { ...state, loading: true };
        case CLEAR_ALL_MARKETS:
            return { ...state, markets: [], eventId: null };
        case SET_ALL_MARKETS_SELECTED_EVENT: {
            const formattedEvent = { ...payload };
            delete formattedEvent.markets;
            return { ...state, selectedEvent: formattedEvent };
        }
        case GET_MARKET_GROUPS: {
            return {
                ...state,
                marketGroups: payload,
            };
        }
        case SET_FILTERED_MARKET_GROUPS: {
            return {
                ...state,
                filteredMarketGroups: payload,
            };
        }
        case SET_SELECTED_MARKET_GROUP: {
            return {
                ...state,
                selectedMarketGroup: payload,
            };
        }
        case SET_MARKETS_COLLAPSED: {
            return {
                ...state,
                isMarketsCollapsed: payload,
            };
        }
        default:
            return state;
    }
}
